import { render, staticRenderFns } from "./PagePart5.vue?vue&type=template&id=4ab7ba69&scoped=true"
import script from "./PagePart5.vue?vue&type=script&lang=js"
export * from "./PagePart5.vue?vue&type=script&lang=js"
import style0 from "./PagePart5.vue?vue&type=style&index=0&id=4ab7ba69&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab7ba69",
  null
  
)

export default component.exports